import React from "react";
import Skeleton from "@mui/material/Skeleton";
import "./ShimmerTable.css";

const defaultColumnCount = 8;

const CommonDataTableShimmer = ({
  rowCount = 8,
  count,
  columnCount = defaultColumnCount,
}) => {
  const finalRows = Number.isInteger(count) ? count : rowCount;
  const headers = Array.from({ length: columnCount });

  return (
    <div className="common-shimmer-table">
      <div className="common-shimmer-toolbar">
        <Skeleton variant="rounded" height={40} width={220} animation="wave" />
        <Skeleton variant="rounded" height={40} width={300} animation="wave" />
      </div>

      <div className="common-shimmer-scroll">
        <table className="common-shimmer-grid">
          <thead>
            <tr>
              {headers.map((_, index) => (
                <th key={`header-${index}`}>
                  <Skeleton variant="text" height={22} width="70%" animation="wave" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: finalRows }).map((_, rowIdx) => (
              <tr key={`row-${rowIdx}`}>
                {headers.map((__, colIdx) => {
                  const isActionCol = colIdx === columnCount - 1;
                  return (
                    <td key={`cell-${rowIdx}-${colIdx}`}>
                      {isActionCol ? (
                        <div className="common-shimmer-actions">
                          <Skeleton variant="circular" width={24} height={24} animation="wave" />
                          <Skeleton variant="circular" width={24} height={24} animation="wave" />
                          <Skeleton variant="circular" width={24} height={24} animation="wave" />
                        </div>
                      ) : (
                        <Skeleton
                          variant="rounded"
                          height={18}
                          width={colIdx === 0 ? "40%" : "85%"}
                          animation="wave"
                        />
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CommonDataTableShimmer;
